// extracted by mini-css-extract-plugin
export var bars = "styles-module--bars--3eeec";
export var controls = "styles-module--controls--649d9";
export var deviceError = "styles-module--deviceError--72412";
export var dynamic = "styles-module--dynamic--d33d3";
export var listening = "styles-module--listening--900e8";
export var microphone = "styles-module--microphone--34344";
export var muted = "styles-module--muted--f5738";
export var speaking = "styles-module--speaking--33015";
export var wrapper = "styles-module--wrapper--01c4f";